import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {SelectItem} from 'primeng/api';
import {GlobalMessagesService} from '../shared/services/messages/global.messages.service';
import {TranslateService} from '@ngx-translate/core';
import {NotificationData} from '../shared/types/notification/notification-data';
import {NotificationType} from '../shared/types/notification/notification-type';
import {SystemType} from '../shared/types/common/system-type';
import {NotificationRestService} from '../shared/services/notification/notification-rest.service';
import {LocalizedValue} from '../shared/types/standard/localized-value';

@Component({
  selector: 'wsd-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {

  notificationForm: UntypedFormGroup;

  notificationTypes: SelectItem[] = [];

  notifications: NotificationData[] = [];

  selectedNotification: NotificationData;

  constructor(private fb: UntypedFormBuilder,
              private notificationRestService: NotificationRestService,
              private globalMessageService: GlobalMessagesService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.notificationForm = this.fb.group({
      subject_en_GB: [''],
      body_en_GB: [''],
      subject_fr_FR: [''],
      body_fr_FR: [''],
      subject_es_ES: [''],
      body_es_ES: [''],
      subject_ru_RU: [''],
      body_ru_RU: [''],
      subject_ar_AE: [''],
      body_ar_AE: ['']
    });
    this.loadNotifications();
  }

  private loadNotifications() {
    this.notificationRestService.getNotifications(SystemType.DIRECTORY).subscribe(
      (data: NotificationData[]) => {
        this.notifications = data;
        this.initNotificationTypes();
      }
    );
  }

  private initNotificationTypes() {
    this.notificationTypes = this.notifications.map(notification => {
      return {
        label: this.translate.instant('NOTIFICATION_TYPE.' + notification.notificationType),
        value: NotificationType[NotificationType[notification.notificationType]]
      };
    });
  }

  notificationChange(event) {
    for (const notification of this.notifications) {
      if (notification.notificationType === event.value) {
        this.setSubject(notification.subject);
        this.setBody(notification.body);
        this.selectedNotification = notification;
      }
    }
  }

  private setSubject(values: LocalizedValue[]) {
    for (const lv of values) {
      this.notificationForm.get('subject_' + lv.langCode).setValue(lv.value);
    }
  }

  private setBody(values: LocalizedValue[]) {
    for (const lv of values) {
      this.notificationForm.get('body_' + lv.langCode).setValue(lv.value);
    }
  }

  save() {
    this.updateData();
    this.notificationRestService.updateNotification(this.selectedNotification).subscribe(
      () => this.globalMessageService.showSuccessMessage(
        this.translate.instant('NOTIFICATIONS.CHANGE_SUCCESS_MESSAGE')),
      () => this.globalMessageService.showErrorMessage(
        this.translate.instant('NOTIFICATIONS.CHANGE_ERROR_MESSAGE'))
    );
  }

  private updateData() {
    for (const lv of this.selectedNotification.subject) {
      lv.value = this.notificationForm.get('subject_' + lv.langCode).value;
    }
    for (const lv of this.selectedNotification.body) {
      lv.value = this.notificationForm.get('body_' + lv.langCode).value;
    }
  }

}
